// @flow
import $ from "jquery";
import * as Immutable from "immutable";
import React from "react";
import type { EditorState } from "draft-js";
import Spinner from "react-spin";
import type { GazelleData } from "../types/gazelle.js";
import ApModal from "./ApModal.js";
import VerticalStackContainer from "./gazelle/VerticalStackContainer.js";
import { fetchGazellePreviewData } from "../utils/gazelle.js";
import { extendedConvertToHTML } from "../utils/draftUtils.js";
import "./PreviewButton.scss";

type Props =
  | {
      editorState: EditorState
    }
  | any;

export default class PreviewButton extends React.Component {
  state: {
    isLoading: boolean,
    isModalOpen: boolean,
    gazelleData: GazelleData
  };
  props: Props;
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
      isModalOpen: false,
      gazelleData: Immutable.List()
    };
    (this: any).onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick(evt: Event) {
    evt.preventDefault();
    const currentHtml = extendedConvertToHTML(
      this.props.editorState.getCurrentContent()
    );
    var authorId = Number($("#id_author").val());
    if (authorId === 0) {
      authorId = null;
    }

    fetchGazellePreviewData({
      type: "blog_post",
      data: {
        title: $("#id_title").val(),
        author_id: authorId,
        body: currentHtml
      }
    }).then(gazelleData => {
      this.setState({
        gazelleData: gazelleData,
        isLoading: false
      });
    });

    this.setState({ isModalOpen: true, isLoading: true });
  }

  render() {
    let modalBody = null;
    if (this.state.isLoading) {
      modalBody = <Spinner />;
    } else {
      modalBody = (
        <VerticalStackContainer gazelleData={this.state.gazelleData} />
      );
    }
    return (
      <div>
        <button
          onClick={this.onButtonClick}
          className="btn wysiwyg-preview-btn"
        >
          Preview
        </button>
        <ApModal
          title="Preview"
          isOpen={this.state.isModalOpen}
          onRequestClose={() => this.setState({ isModalOpen: false })}
        >
          <div style={{ width: "320px" }}>{modalBody}</div>
        </ApModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/PreviewButton.js